<!-- BackbarPageLayout provides a general template with backbar.

     Backbar is constructed as sticky element with white background.
     Use mainly for detail page -->
<template>
  <loading-spinner
    v-if="loading"
    class="container-content"
  />
  <div v-else>
    <b-row class="position-sticky no-gutters bg-white border-bottom" :style="{ top: offsetTop + 'px', zIndex: 1 }">
      <b-container>
        <b-row>
          <b-button
            class="border-0 text-dark btn-back"
            variant="link"
            @click="goBack"
          >
            <i class="mr-2 text-decoration-none ac-icon ac-left-arrow ac-left-arrow-grey-dark"></i>
            <span class="btn-link text-dark">{{ $t(backTitle) }}</span>
          </b-button>
        </b-row>
      </b-container>
    </b-row>
    <slot name="alert"></slot>
    <b-container class="mt-4 pt-backbar">
      <b-row>
        <b-col>
          <h1 class="my-0 font-weight-bold">{{ $t(title) }}</h1>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col>
          <div class="shallow-transparency">
            {{ description }}
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="!hideProfile"
        align-v="center"
      >
        <b-col>
          <b-row align-v="center">
            <!-- TODO: profile icon - ref: https://gitlab.com/blocksq/authcore/issues/69 -->
            <b-col cols="auto" class="details-monogram" :data-letter="firstCharProfileName"></b-col>
            <b-col cols="auto" class="mt-3">
              <b-row class="h5 my-0 font-weight-light font:1.375rem">
                {{ profileName }}
              </b-row>
              <b-row class="small text-danger">
                {{ $t(locked) }}
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-right">
          <slot name="action"></slot>
        </b-col>
      </b-row>
    </b-container>
    <slot name="default"></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import router from '@/router'
import store from '@/store'

import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default {
  name: 'BackbarPageLayout',
  components: {
    LoadingSpinner
  },

  props: {
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideProfile: {
      type: Boolean,
      default: false
    },
    backTitle: {
      type: String,
      default: 'general.back'
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    roleName: {
      type: String,
      default: 'general.blank'
    },
    userId: {
      type: Number,
      default: -1
    },
    loading: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      offsetTop: 0
    }
  },

  computed: {
    ...mapState('management/userDetails', [
      'user'
    ]),
    profileName () {
      if (this.user.displayName !== undefined) {
        return this.user.displayName
      } else if (this.user.username !== undefined) {
        return this.user.username
      } else if (this.user.email !== undefined) {
        return this.user.email
      } else if (this.user.phone !== undefined) {
        return this.user.phone
      }
      return 'No data shown'
    },
    firstCharProfileName () {
      return this.profileName[0].toUpperCase()
    },
    locked () {
      return this.user.locked ? 'general.locked' : 'general.blank'
    }
  },

  async mounted () {
    const { userId } = this
    if (userId !== -1) {
      await store.dispatch('management/userDetails/get', userId)
    }

    // Set the top of elements to have sticky position
    // The offset top is according to the navbar height as sticky position requires
    // explictly set the top as the sticky threshold. In the case the backbar should
    // be sticky after the navbar height, which the threshold should be navbar height.
    this.offsetTop = this.$el.offsetTop
  },

  methods: {
    goBack () {
      router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
button.btn-back {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
